<template>
  <div
    class="prompt"
    v-if="payError.show"
    @touchmove.prevent
  >
    <div class="pay-error">
      <p class="e-tip">
        {{ payError.msg }}
      </p>
      <v-button
        @click="close"
      >
        我知道了
      </v-button>
    </div>
  </div>
</template>

<script>
  import vButton from './Button'

  export default {
    name: 'PayError',
    props: {
      payError: {
        type: Object,
        default () {
          return {
            show: false
          }
        }
      }
    },
    methods: {
      close () {
        this.$emit('close')
      }
    },
    components: {
      vButton
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/common.scss";

  .pay-error {
    background-color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-bottom: 72px;
    z-index: 101;
    border-top: 1PX solid #eee;
    text-align: center;
    font-size: 45px;
    .e-tip {
      color: #222;
      padding: 105px 0 72px;
    }
  }
</style>
